// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoResults-root-sd_Ow {
    margin: 0px 20px;
}

.NoResults-container-Cb_Bs {
    margin: 64px 40px 96px;
}

.NoResults-headingText-uoK6B {
    font-weight: 600;
    color: var(--common-text-color);
    margin: 0px;
    word-wrap: break-word;
    font-size: 24px;
    letter-spacing: -0.6px;
    padding-top: 28px;
    padding-bottom: 8px;
}

.NoResults-subHeading-PYLE7 {
    color: var(--common-text-color);
    margin: 0px;
    word-wrap: break-word;
    font-size: 18px;
}

.NoResults-imgWidth-rz2ox {
    width: 360px;
}

.NoResults-textCenter-KVwB0 {
    text-align: center;
}

@media screen and (max-width: 767px) {
    .NoResults-imgWidth-rz2ox {
        width: 100%;
    }

    .NoResults-container-Cb_Bs {
        margin: 115px 40px 96px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/NoResults/NoResults.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".root {\n    margin: 0px 20px;\n}\n\n.container {\n    margin: 64px 40px 96px;\n}\n\n.headingText {\n    font-weight: 600;\n    color: var(--common-text-color);\n    margin: 0px;\n    word-wrap: break-word;\n    font-size: 24px;\n    letter-spacing: -0.6px;\n    padding-top: 28px;\n    padding-bottom: 8px;\n}\n\n.subHeading {\n    color: var(--common-text-color);\n    margin: 0px;\n    word-wrap: break-word;\n    font-size: 18px;\n}\n\n.imgWidth {\n    width: 360px;\n}\n\n.textCenter {\n    text-align: center;\n}\n\n@media screen and (max-width: 767px) {\n    .imgWidth {\n        width: 100%;\n    }\n\n    .container {\n        margin: 115px 40px 96px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NoResults-root-sd_Ow`,
	"container": `NoResults-container-Cb_Bs`,
	"headingText": `NoResults-headingText-uoK6B`,
	"subHeading": `NoResults-subHeading-PYLE7`,
	"imgWidth": `NoResults-imgWidth-rz2ox`,
	"textCenter": `NoResults-textCenter-KVwB0`
};
module.exports = ___CSS_LOADER_EXPORT___;
